<template>
  <v-app class="grey lighten-4">
    <Navbar 
    :userName="userData? userData.displayName ? userData.displayName :  userData.email : null "
    :userImage="userData? userData.photoURL ? userData.photoURL : null : null "
    :progress="progress"
    :scroll="scroll"
    :language="language"
    :superAdmin="superAdmin"
    :scrollAmount="scrollAmount"
    :connection="connection"
    :cartcount="cartcount"
    :cartTotal="cartTotal"
    :symbol="symbol"
    :newCountry="newCountry"
    @showCart="showCart()"
    />
    
    <v-content>
      <v-alert
        :value="alert"
        :type="type"
        transition="scale-transition"
      >
        {{ alertText }}
      </v-alert>
      <transition :name="transitionName"> 
        <router-view
          :isLogin="isLogin"
          :userRole="userRole"
          :beta="beta"
          :superAdmin="superAdmin"
          :userData="userData? userData : null"
          :userName="userData? userData.displayName ? userData.displayName : userData.email : null"
          :userImage="userData? userData.photoURL ? userData.photoURL : null : null"
          :showCart="showcart"
          
          @language="getLanguage"
          @snackbarNotification="getSnack"
          @alertNotification="getAlert"
          @progressBar='getProgress'
          @scrollBar="getScroll"
          @cart="getCart"
          @hideCart="hideCart"
          @showCart="showCart()"
          @country="newCountryC"
        ></router-view>
      </transition>
    </v-content>
      <v-snackbar v-model="snackbar" :color="type" :timeout="4000" bottom >
        <span>{{ snackbarContent }}</span>
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <!-- <Chat /> -->
    <Footer />
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/footer'
import { firebase, db, auth, perf } from '@/fb'
const trace = perf.trace('inAppTime');

export default {
  components: { Navbar, Footer},
  name: 'App',
  data () {
    return {
      isLogin:false,
      transitionName:null,
      userData:null,
      snackbar:false,
      snackbarContent:'',
      alert:false,
      alertText:null,
      type:null,
      progress:null,
      scroll:false,
      connection:null,
      userRole:null,
      scrollAmount:0,
      beta:null,
      superAdmin:null,
      cartcount:0,
      factor:1,
      symbol:'$',
      cartTotal:0,
      showcart:false,
      language:'en',
      newCountry:null,
    }
  },
  methods: {
    newCountryC(c){
      this.newCountry = c
    },
    getLanguage(l){
      this.language = l
    },
    hideCart(){
      this.showcart = false
    },
    showCart(){
      this.showcart = true
    },
    getCart(items, cSymbol, factor){
      this.cartcount = items.filter(x=> x != null).length
      this.factor = factor
      this.symbol = cSymbol
      if(items.filter(x=> x != null).length>0)
      this.cartTotal = (items.filter(x=> x != null).map(x=>x.price).reduce((a, b)=> a + b) * this.factor).toFixed(1)
    },
    getSnack (text, type) {
      this.snackbar = true
      this.snackbarContent = text
      this.type = type
    },
    getAlert (text, type) {
      this.alert = true
      this.alertText = text
      this.type = type
      setTimeout(()=>{this.alert = false}, 4000)
    },
    getProgress(val){
      this.progress = val
    },
    getScroll(status, amount) {
      this.scroll=status
      this.scrollAmount=amount
    },
    showSnackbar (text, type) {
      this.$emit('snackbarNotification', text, type)
    },
    statusCheck(){
      var connectedRef = firebase.database().ref(".info/connected");
      connectedRef.on("value", (snap) => {
        if (snap.val() === true) {
          this.getSnack ('You are now connected', 'success')
          this.connection = 'success'
        } else {
          this.getSnack ('You are not connected', 'error')
          this.connection = 'error'
        }
      });
      let updateIndicator = () => {
        if(navigator.onLine) { // true|false
          this.getSnack ('You are now Online', 'success')
          this.connection = 'success'
        } else {
          this.getSnack ('You are now Offline', 'error')
          this.connection = 'error'
        }
      }
      window.addEventListener('online',  updateIndicator);
      window.addEventListener('offline', updateIndicator);
    }
  }, 
  watch: {
    $route (to, from){
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  created() {
    auth.onAuthStateChanged(user => {
      if (user) {
        this.isLogin = true;
        this.userData = user;
        this.$store.state.user = user
        this.$emit('signedIn', this.userData)
        this.statusCheck() 
        var d = new Date();
        var store = Date.parse(d)
        var offset = d.getTimezoneOffset();
        console.log(new Date(store))
        let newUser = {
          user_id: user.uid,
          email: user.email,
          name: user.displayName,
          phone: user.phoneNumber,
          qa: user.qa,
          // role:'user',
          provider: user.providerData,
          timeoffset: offset,
          lastSeen:store,

        }
        db.ref(`users/${user.uid}`)
        .update(newUser)
        db.ref(`users/${user.uid}`)
        .on('value', snap=>{
          if (snap.val()) {
            let x = snap.val()
            this.$store.state.user = x
            this.$store.state.role = x.role ? x.role : 'user'
            this.userRole = x.role ? x.role : 'user'
            this.beta = x.beta
            this.superAdmin = x.superadmin
          }
        })
      } else {
        this.isLogin = false;
        this.userData = null;
        this.superAdmin = false
      }
    });
    trace.start();
  },
  mounted() {
  },
  destroyed(){
    trace.stop();
  }
}
</script>
<style>
::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.22);
    background-color: #106342;
}

::-webkit-scrollbar
{
	width: 5px;
	background-color: #106342;
}

::-webkit-scrollbar-thumb
{
	background-color: #008f56;
	border-radius:  0 0 20px 20px; 
}
.arFont { 
  font-family: 'Cairo', sans-serif !important;
}

.RLT {
  direction: rtl !important;
}

.RIGHT {
  text-align: right  !important;
}
</style>
